<script lang="ts">
    import draftToHtml from 'draftjs-to-html';
    import Box from './_wrappers/Box.svelte';
    import clsx from 'clsx';

    // Types
    import type { Box as BoxType } from '$lib/types/Component';
    import type { RawDraftContentState } from 'draft-js';
    import type { Align } from '$lib/types/Component';
    import type { TransitionEffect } from '$lib/types/Theme';

    export let raw: RawDraftContentState;
    export let color = 'black';
    export let align: Align = 'left';
    export let linkColor = '#0076FF';
    export let inheritSize = false;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let wide = false;
    export let noDesktopScaling = false;
    export let responsive = true;
    export let box: BoxType;

    let classes: string;

    $: html = draftToHtml(raw);
    $: classes = clsx({
        'lg:px-0': noDesktopScaling,
        'text-left': align === 'left',
        'text-center': align === 'center',
        'text-right': align === 'right',
    });
</script>

<Box {...box} {transitionDelay} {transitionEffect} {wide}>
    <div
        class="wrapper break-words {classes}"
        class:inheritSize
        class:responsive
        style="--textColor: {color}; --linkColor: {linkColor};"
    >
        {@html html}
    </div>
</Box>

<style lang="scss">
    .wrapper {
        color: var(--textColor);

        /*Links*/
        :global(a) {
            color: var(--linkColor);
            text-decoration: underline;
        }

        :global(h1) {
            @apply m-0;
        }

        :global(h2) {
            @apply m-0;
        }
        :global(h3) {
            @apply m-0;
        }
        :global(h4) {
            @apply m-0;
        }
        :global(h5) {
            @apply m-0;
        }
        :global(ul) {
            @apply m-0;
        }
        :global(li) {
            @apply m-0;
        }
        :global(p) {
            @apply m-0;
        }

        /*SIZE_XL*/
        :global(h1) {
            @apply text-3xl font-normal;
        }

        &.responsive :global(h1) {
            @apply sm:text-4xl md:text-5xl md:leading-tight;
        }

        /*SIZE_L*/
        :global(h2) {
            @apply text-2xl;
        }

        &.responsive :global(h2) {
            @apply sm:text-3xl md:text-4xl;
        }

        &.responsive:not(.text-left) :global(h2) {
            @apply lg:px-16;
        }

        /*SIZE_M*/
        :global(h3) {
            @apply text-xl;
        }

        &.responsive :global(h3) {
            @apply md:text-2xl;
        }

        /*SIZE_S*/
        :global(h4) {
            @apply text-base;
        }

        :global(p) {
            @apply text-base;
        }

        &.responsive:not(.text-left) :global(h4) {
            @apply lg:px-16;
        }

        &.responsive:not(.text-left) :global(p) {
            @apply lg:px-16;
        }

        /*SIZE_CHECKBOX*/
        :global(h5) {
            @apply font-normal;
            font-size: 14px;
            line-height: 21px;
        }

        /* LISTS */
        :global(ul) {
            @apply p-0;
            list-style-type: none;
        }

        :global(li) {
            @apply pb-2;
        }

        :global(p) {
            @apply font-normal;
        }

        &.inheritSize {
            /*SIZE_XL*/
            :global(h1) {
                font-size: inherit;
                line-height: inherit;
                font-weight: inherit;
            }

            /*SIZE_L*/
            :global(h2) {
                font-size: inherit;
                line-height: inherit;
                font-weight: inherit;
            }

            /*SIZE_M*/
            :global(h3) {
                font-size: inherit;
                line-height: inherit;
                font-weight: inherit;
            }

            /*SIZE_S*/
            :global(h4) {
                font-size: inherit;
                line-height: inherit;
                font-weight: inherit;
            }

            /*SIZE_CHECKBOX*/
            :global(h5) {
                font-size: inherit;
                line-height: inherit;
                font-weight: inherit;
            }

            :global(p) {
                font-size: inherit;
                line-height: inherit;
                font-weight: inherit;
            }
        }
    }
</style>
